import actions from '../../actionTypes';

export default (siteId, nodeAddress) => {
  return {
    type: actions.DELETE_SITE_GATEWAY,
    siteId,
    nodeAddress
  };
};



// WEBPACK FOOTER //
// ./src/reducers/status/actions/deleteSiteGateway.js